export default __webpack_public_path__ + "static/media/LogoSaintWhite.419339bf.png";